import React from "react"
import styled from "styled-components"
import { useLocation } from "@reach/router"
import { rem } from "polished"
import { Link } from "gatsby"
import { media } from "@sr/common"
import { appHeaderHeight } from "@sr/gatsby-theme-ui"

const CommunityWifiNav = () => {
  const location = useLocation()
  const currentPath = location.pathname

  const communityWifiPages = [
    {
      title: "Community WiFi",
      path: "/products/community-wifi/",
    },
    {
      title: "Benefits",
      path: "/products/community-wifi/benefits/",
    },
    {
      title: "New Construction",
      path: "/products/community-wifi/new-construction/",
    },
    {
      title: "Retrofit",
      path: "/products/community-wifi/retrofit/",
    },
    {
      title: "Services",
      path: "/products/community-wifi/services/",
    },
    {
      title: "NOI Calculator",
      path: "/products/community-wifi/noi-calculator/",
    },
  ]

  return (
    <CommunityWifiNavStyled headerHeight={appHeaderHeight}>
      <ul>
        {communityWifiPages.map((page, i) => {
          return (
            <li key={i} className={currentPath === page.path ? "active" : ""}>
              <Link to={page.path}>{page.title}</Link>
            </li>
          )
        })}
      </ul>
    </CommunityWifiNavStyled>
  )
}

interface CommunityWifiNavStyledSC {
  headerHeight: number
}

const CommunityWifiNavStyled = styled.nav<CommunityWifiNavStyledSC>`
  width: 100%;
  height: ${rem(48)};
  display: flex;
  align-items: center;
  overflow-x: auto;
  position: sticky;
  top: ${({ headerHeight }) => rem(headerHeight)};
  z-index: 3;
  border: ${rem(1)} solid var(--color-gray200);
  background: var(--color-gray050);

  /* Hide scrollbar for WebKit browsers */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for other browsers */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  ul {
    display: flex;
    gap: ${rem(20)};
    white-space: nowrap;
    padding: 0 ${rem(20)};

    @media ${media.midUp} {
        gap: ${rem(40)};
    }

    li {
      width: auto;
      /* height: ${rem(16)}; */

      a {
        font-size: ${rem(14)};
        color: var(--color-gray900);
        text-decoration: none;
      }
    }

    .active {
      border-bottom: ${rem(2)} solid var(--color-primary);
    }
  }
`

export default CommunityWifiNav
